import Cookies from 'js-cookie';
import genericHelpers from '../_utils/generic-helpers';
import Store from '../_utils/tools/store';

const shouldSaveCookies = Store.isWalmart();

function setDeliveryLocation(url, zipCode) {
  if (![url, zipCode, shouldSaveCookies].every(Boolean)) {
    return;
  }

  // Cookies formats: https://redmine.livelink.io/issues/8719#note-7
  // DL; e.g. DL=94404%2Cempty%2Cempty%2Cuser%2C94404%2CUSA%2CCA
  genericHelpers.promisifiedXHR(url, 'GET', { zip_code: zipCode })
    .then((location) => {
      const value = encodeURIComponent([location.zipcode,
        location.latitude,
        location.longitude,
        'user',
        location.zipcode,
        location.country,
        location.state].join());

      Cookies.set('DL', value, { domain: 'walmart.com', path: '/' });
    }).catch((error) => console.error(error));
}

function setNearestStores(locations) {
  if (!shouldSaveCookies) {
    return;
  }
  
  const value = locations.map((location) => `${location.id}.${Math.round(location.distance.miles)}`).join('-');

  Cookies.set('NSID', value, { domain: 'walmart.com', path: '/' });
}

export default { setDeliveryLocation, setNearestStores };
